var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10.6667,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.8885C30 25.0551 25.7333 30.8218 20 32.2218C14.2667 30.8218 10 25.0551 10 18.8885V12.2218L20 7.77734L30 12.2218V18.8885ZM20 29.9996C24.1667 28.8885 27.7778 23.9329 27.7778 19.1329V13.6662L20 10.1996L12.2222 13.6662V19.1329C12.2222 23.9329 15.8333 28.8885 20 29.9996ZM23.1111 18.8885V17.2218C23.1111 15.6662 21.5556 14.444 20 14.444C18.4444 14.444 16.8889 15.6662 16.8889 17.2218V18.8885C16.2222 18.8885 15.5556 19.5551 15.5556 20.2218V24.1107C15.5556 24.8885 16.2222 25.5551 16.8889 25.5551H23C23.7778 25.5551 24.4444 24.8885 24.4444 24.2218V20.3329C24.4444 19.5551 23.7778 18.8885 23.1111 18.8885ZM21.6667 18.8885H18.3333V17.2218C18.3333 16.3329 19.1111 15.7773 20 15.7773C20.8889 15.7773 21.6667 16.3329 21.6667 17.2218V18.8885Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityNav);
export default __webpack_public_path__ + "static/media/security-nav.c9622a0fc95b0c540ed24dabd152fe0b.svg";
export { ForwardRef as ReactComponent };